import { FormProvider, useForm } from 'react-hook-form'
import useTranslation from 'next-translate/useTranslation'
import moment from 'moment'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import { checkoutCapacityConflictAvailableTimesSelector } from '../../store/checkoutSelectors'
import useCapacityConflictActions from '../../hooks/useCapacityConflictActions'

import CapacityConflictLaterTimesGrid from './CapacityConflictLaterTimesGrid'
import CapacityConflictFooter from './CapacityConflictFooter'
import CapacityConflictStepDescription from './CapacityConflictStepDescription'

export type CapacityConflictFormValues = {
  selectedPickupTime: string | null
}

const defaultFormValues: CapacityConflictFormValues = {
  selectedPickupTime: null,
}

export default function CapacityConflictSelectTimeStep() {
  const { t } = useTranslation('common')

  const times = useAppSelector(checkoutCapacityConflictAvailableTimesSelector)
  const { isPending, scheduleAt } = useCapacityConflictActions()

  const form = useForm<CapacityConflictFormValues>({
    defaultValues: defaultFormValues,
  })
  const selectedTime = form.watch('selectedPickupTime')

  function handleSchedule() {
    if (selectedTime) {
      scheduleAt(selectedTime)
    }
  }

  const formattedSelectedTime = selectedTime
    ? moment(selectedTime).format('LT')
    : ''

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormProvider {...form}>
      <CapacityConflictStepDescription>
        {t('checkoutCapacityConflict.timeStepMessage')}
      </CapacityConflictStepDescription>
      <CapacityConflictLaterTimesGrid times={times} />
      <CapacityConflictFooter
        primaryLabel={
          formattedSelectedTime
            ? t('checkoutCapacityConflict.scheduleButtonWithTime', {
                time: formattedSelectedTime,
              })
            : t('checkoutCapacityConflict.scheduleButton')
        }
        onPrimaryClick={handleSchedule}
        primaryDisabled={!selectedTime || isPending}
      />
    </FormProvider>
  )
}
